<template>
  <tg-layout :headerHeight="120">
    <template slot="header">
      <el-row type="flex" justify="space-between">
        <TgSearchTool @on-submit="handleSearch">
          <TgDateSearch
            ref="dateSearch"
            size="small"
            v-model="dateRange"
            showDateRangePicker
            showTomorrow
            twoMonthLimit
          ></TgDateSearch>
          <el-input
            :placeholder="$t('column.amount')"
            v-model="searchData.amount"
            class="tg-input input-search-username"
            size="small"
            clearable
          ></el-input>
        </TgSearchTool>
      </el-row>
      <el-row style="padding: 5px">
        <!-- 平台選擇按鈕 -->
        <ThirdPartySearchBtn
          :style="{ display: showThirdParty ? 'initial' : 'none' }"
          @click.native="showThirdPartyCheckBoxDialog"
        ></ThirdPartySearchBtn>
        <ThirdPartyPlatform
          :style="{ display: showThirdParty ? 'initial' : 'none' }"
          v-model="thirdPartyData"
          @on-change="handleSearchThirdParty"
        ></ThirdPartyPlatform>
      </el-row>
    </template>

    <TgTable
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      @on-loaded="handleLoaded"
      showPagination
    >
      <!-- 平台 -->
      <template slot="platform" slot-scope="scope">
        <div v-for="(item, index) in scope.row.platform" :key="index">
          {{ $t(`component.label.source_type.${item.code}`) }}：
          <span
            :class="{
              'text-red': Number(item.result) < 0,
              'text-green': Number(item.result) > 0,
            }"
          >
            {{ item.result }}
          </span>
          <br />
        </div>
      </template>
    </TgTable>

    <!-- 平台篩選彈窗 -->
    <ThirdPartyCheckBoxDialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="thirdPartyData"
      @on-click="handleSearchThirdParty"
    ></ThirdPartyCheckBoxDialog>

    <TgDialog
      theme="warning"
      :showIcon="true"
      :title="$t(`component.dialog.title`)"
      :visible.sync="showDialog"
      append-to-body
      top="35vh"
      width="20%"
      @on-confirm="handleDialogConfirm"
      :showCancelBtn="true"
    >
      <!-- 查詢金額須大於50,000 -->
      <div>{{ $t(`message.error.min_mount`) }}</div>
    </TgDialog>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgSearchTool from "@/components/tool/TgSearchTool";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from "@/components/tool/ThirdPartyPlatform";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import TgDialog from "@/components/dialog/TgDialog";
import TgTable from "@/components/table/TgTable";
import apis from "@/apis";

const api = apis.accounts.high_profit_members;
const STORE_UPDATE = "pages/accounts/hightProfitMembers/update";

export default {
  components: {
    TgLayout,
    TgDateSearch,
    TgSearchTool,
    ThirdPartySearchBtn,
    ThirdPartyPlatform,
    ThirdPartyCheckBoxDialog,
    TgDialog,
    TgTable,
  },
  data() {
    return {
      columns: [],
      proxy: api.getData,
      dateRange: {},
      showMarketTypeFilter: true,
      searchData: {
        amount: "50000",
        third_party: [],
      },
      reload: false,
      thirdPartyArr: [],
      serviceTitle: "",
      cancelLabel: "",
      showDialog: false,
    };
  },
  computed: {
    store() {
      return this.$store.state.pages.accounts.hightProfitMembers;
    },
    thirdPartyData: {
      get() {
        return this.$store.state.pages.accounts.hightProfitMembers
          .thirdPartyData;
      },
      set(val) {
        this.$store.commit(STORE_UPDATE, { thirdPartyData: val });
      },
    },
  },
  created() {
    api.getColumns().then((response) => {
      this.columns = response.data.columns;
    });
  },
  methods: {
    async handleSearchThirdParty(value) {
      this.thirdPartyData = value;
      this.platforms = this.thirdPartyData.map((r) => {
        return r.platform;
      });
      await this.handleSearch();
    },
    async handleSearchMarketType(values) {
      const params = await this.getSubmitValidate();
      // 不查三方
      if (values.indexOf("-1") === -1) {
        params.third_party = ["tg"];
      } else {
        if (values.length == 1) {
          params.third_party = params.third_party.filter((x) => x != "tg");
        }
      }
      this.searchData.market_type = values.filter((x) => x != -1);

      await this.$refs.table.search(params);
    },
    showThirdPartyCheckBoxDialog() {
      this.$refs.thirdPartyCheckBoxDialog.showDialog();
    },
    // 查詢
    async handleSearch() {
      const params = await this.getSubmitValidate();
      this.$nextTick(() => {
        this.$refs.table.search(params);
      });
    },
    getSubmitValidate() {
      if (this.searchData.amount !== "" && this.searchData.amount < "50000") {
        this.showDialog = true;
        return;
      }
      this.searchData.amount =
        this.searchData.amount === "" ? "50000" : this.searchData.amount;
      const params = {
        ...this.searchData,
        ...this.dateRange,
        third_party: this.thirdPartyData.map((item) =>
          item.platform ? item.platform : item.key
        ),
      };
      return params;
    },
    // 處理response
    handleLoaded(response) {
      if (response.retcode == 0) {
        this.hasData = response.data.length > 0;
        this.showAmount = response.data.length > 0;

        let columns = JSON.parse(JSON.stringify(this.columns));

        this.columns = columns;

        this.amountTotalData = response.amount_total;
        this.amountPageData = response.amount_page;
      }
    },
    handleDialogConfirm() {
      this.showDialog = false;
    },
  },
};
</script>
